import { SelectionGroupOption } from 'common/components';
import { Solution } from '../solution-card';

export const KIDS_SOLUTION_TAB_LIST: SelectionGroupOption[] = [
  { value: '1', text: 'Стеллаж-перегородка' },
  { value: '2', text: 'Стеллаж' },
  { value: '3', text: 'Шкаф' },
];

export const KIDS_SOLUTION_CONTENT_MAP: Record<string, Solution> = {
  '1': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/1-1.jpg/1-1.jpg',
    imgAlt: 'Стеллаж-перегородка',
    title: 'Стеллаж-перегородка',
    size: '144 × 144 × 32 см',
    productIds: ['82731911', '82731912', '82731882', '82731875', '82020864', '82731898'],
    '82731911': {
      productCount: 1,
    },
    '82731912': {
      productCount: 1,
    },
    '82731882': {
      productCount: 1,
    },
    '82731875': {
      productCount: 2,
    },
    '82020864': {
      productCount: 2,
    },
    '82731898': {
      productCount: 1,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-detskaya-stellazh-peregorodka',
  },
  '2': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/1-2.jpg/1-2.jpg',
    imgAlt: 'Стеллаж',
    title: 'Стеллаж',
    size: '144 × 144 × 32 см',
    productIds: ['82731911', '82731908', '82731887', '82731902', '82020864', '82020863', '82036412'],
    '82731911': {
      productCount: 5,
    },
    '82731908': {
      productCount: 1,
    },
    '82731887': {
      productCount: 4,
    },
    '82731902': {
      productCount: 2,
    },
    '82020864': {
      productCount: 3,
    },
    '82020863': {
      productCount: 1,
    },
    '82036412': {
      productCount: 6,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-detskaya-stellazh',
  },
  '3': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/1-3.jpg/1-3.jpg',
    imgAlt: 'Шкаф',
    title: 'Шкаф',
    size: '180 × 144 × 32 см',
    productIds: [
      '82731884',
      '82731914',
      '82731879',
      '82731911',
      '82731908',
      '82731887',
      '82731898',
      '82731904',
      '82731902',
      '82731905',
      '82036412',
    ],
    '82731884': {
      productCount: 1,
    },
    '82731914': {
      productCount: 1,
    },
    '82731879': {
      productCount: 1,
    },
    '82731911': {
      productCount: 1,
    },
    '82731908': {
      productCount: 1,
    },
    '82731887': {
      productCount: 2,
    },
    '82731898': {
      productCount: 1,
    },
    '82731904': {
      productCount: 5,
    },
    '82731902': {
      productCount: 6,
    },
    '82731905': {
      productCount: 2,
    },
    '82036412': {
      productCount: 5,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-detskaya-shkaf',
  },
};
